import { FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_BENEFICIARIES_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/completingActions/beneficiaries';
import { FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_DETAILS_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/completingActions/details';
import { FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_INVOLVEMENTS_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/completingActions/involvements';
import { FintracFormSingleField } from 'app/modules/fintracStr/models';

export const FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_FIELDS: FintracFormSingleField =
  {
    type: 'section',
    repeatable: true,
    label: 'Completing Actions',
    name: 'completingActions',
    mustExistInPayload: true,
    mustHaveValueIfExist: true,
    maxRepeat: 50,
    fields: [
      FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_DETAILS_FIELDS,
      FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_INVOLVEMENTS_FIELDS,
      FINTRAC_STR_TRANSACTION_COMPLETING_ACTIONS_BENEFICIARIES_FIELDS,
    ],
  };
